import React from 'react';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../hooks/useRouter';
import Loader from '../../components/Loader';
import EmptyState from '../../@communityshare/ui/EmptyState';
import classNames from 'classnames';
import PropTypes from 'prop-types';

Results.propTypes = {
  children: PropTypes.func.isRequired
}

export default function Results(props) {
  const {
    result,
    children,
    columns = 4,
    resource= 'results',
    emptyIcon
  } = props;

  const { location, history } = useRouter();

  if (result.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (result.data.length === 0) {
    return (
      <EmptyState
        icon={emptyIcon}
        title="Can't find what you're looking for?"
        subtitle={(
          <div className="max-w-screen-sm m-auto space-y-6">
            <div>
              Don't worry - there might be more {resource} here.
            </div>
            <div className="mt-1 text-cs-gray-500 space-x-1">
              <span>Remove a filter, or start over and</span>
              <span
                className="text-cs-orange-500 underline cursor-pointer"
                onClick={() => history.push(location.pathname)}
              >
                clear all filters
              </span>.
            </div>
          </div>
        )}
      />
    );
  }

  return (
    <div className={classNames(
      result._isPreviousData && 'opacity-50',
      'w-full grid grid-cols-1 gap-4',
      columns > 1 && 'sm:grid-cols-2',
      columns > 2 && 'lg:grid-cols-3',
      columns > 3 && 'xl:grid-cols-4',
    )}>
      {result.data.map(children)}
    </div>
  );
}
